import React from 'react';
import './Investor.scss'
import { InvestorApi } from "@/fetch";
import { AppHeader, AppFooter } from '@/components'
import { Route, } from 'react-router-dom'
const $ = window.$;
class Investor extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      activeTab: '特别提示',
      bannerImages: [
        { imgPath: require("img/Investor.png"), imgHDPath: `${require("img/Investor.png")} 1x,${require("img/Investor@2x.png")} 2x,${require("img/Investor@3x.png")} 3x`, attachURL: "/" },
      ],
      title: [
        { name: '特别提示', value: '特别提示' },
        { name: '定期报告', value: '定期报告' },
        { name: '投资者关系活动', value: '投资者关系活动' },
        { name: '三会运作', value: '三会运作' },
        { name: '治理制度', value: '治理制度' },
        { name: '公司公告', value: '公司公告' },
        { name: '投资者互动交流', value: '投资者互动交流' },
        { name: '投资者联系方式', value: '投资者联系方式' }
      ],
      InvestorList: [],
      off_on: false,
    }
    this.startx = null;                 //触摸起始点x轴坐标
    this.starty = null;                 //触摸起始点y轴坐标
    this.zise = 1;
  }
  componentDidMount() {
    const that = this
    that.stickFn()
    that.getNoticeByCondition()
  }

  handleNavToggle(e, value) {
    if (value === '投资者互动交流') {
      window.open('https://wxly.p5w.net/ir.html', '_blank')
    } else {
      this.setState({ activeTab: value })
      this.setState({ InvestorList: [] });
      this.getNoticeByCondition(1, value)
      window.scrollTo(0, 0)
      // this.state.navSwiper.slideTo(value)
    }

  }
  stickFn() {
    const top1 = document.getElementsByClassName('top')[0];
    const top2 = document.getElementsByClassName('top')[1];
    const fixedHeight = top1.clientHeight + top2.clientHeight
    $(window).scroll(function () {
      var scroH = $(this).scrollTop();
      console.log(scroH, fixedHeight, 'scroH');
      if (scroH > fixedHeight) {
        $(".type-nav").css({ "position": "fixed", "top": 0, "display": "flex", "justifyContent": "spaceAround", "alignItems": "center", "zIndex": 2, "width": 'calc(100% - 40px)', "background": "rgb(247, 247, 247)" });
      } else if (scroH <= fixedHeight) {
        $(".type-nav").css({ "position": "static" });
      }
    });
  }
  /**
 * 获取接口数据
 */
  getNoticeByCondition(page = 1, tab = '') {
    let that = this;
    InvestorApi.getNoticeByCondition({
      special: tab === '特别提示' || tab === '' ? true : '',
      displayType: tab === '公司公告' || tab === '特别提示' ? '' : tab,
      page: page,
      size: 10,
      status: true,
    })
      .then(res => {
        if (JSON.stringify(res.page.content) !== '[]') {
          that.setState({ InvestorList: that.state.InvestorList.concat(res.page.content) }, () => { });
          that.setState({ off_on: true })
          that.forceUpdate();
        } else {
          that.setState({ off_on: false })
        }
      })
      .catch(err => console.log(err))
  }
  getAngle(angx, angy) {
    return Math.atan2(angy, angx) * 180 / Math.PI;
  };
  //根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
  getDirection(startx, starty, endx, endy) {
    var angx = endx - startx;
    var angy = endy - starty;
    var result = 0;

    //如果滑动距离太短
    if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
      return result;
    }

    var angle = this.getAngle(angx, angy);
    if (angle >= -135 && angle <= -45) {
      result = 1;
    } else if (angle > 45 && angle < 135) {
      result = 2;
    } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
      result = 3;
    } else if (angle >= -45 && angle <= 45) {
      result = 4;
    }

    return result;
  }
  touchStart(e) {
    e.preventDefault();
    this.startx = e.touches[0].pageX;
    this.starty = e.touches[0].pageY;
  }
  touchEnd(e) {
    e.stopPropagation();
    let that = this;
    var endx, endy;
    endx = e.changedTouches[0].pageX;
    endy = e.changedTouches[0].pageY;
    var direction = this.getDirection(this.startx, this.starty, endx, endy);
    switch (direction) {
      // case 0:
      //     // console.log('没动')
      //     break;
      case 1:
        if (that.state.off_on) {
          that.state.off_on = false;
          that.zise++;
          that.getNoticeByCondition(that.zise, that.state.activeTab)
        }
        break;
      // case 2:
      //     console.log('下')
      //     break;
      case 3:
        console.log('左')
        break;
      // case 4:
      //     console.log('又')
      //     break;
      default:
    }

  }
  render() {
    return (
      <div className='Investor' onTouchStart={this.touchStart.bind(this)} onTouchEnd={this.touchEnd.bind(this)}>

        <Route component={AppHeader} />
        <main className="Investor-body">
          <section className="swiper-container">
            <div className="swiper-wrapper">
              {
                this.state.bannerImages.map((item, index) =>
                  <img key={index} className='top bannerImg' src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" />
                )
              }
            </div>
            <div className="swiper-pagination"></div>
            <h5>投资者关系</h5>
            <p>青矩技术 | 股票代码：920208</p>
          </section>
          <ul className="type-nav">
            {
              this.state.title.map((item, index) =>
                <li className={`type-navbars-title ${this.state.activeTab === item.name ? 'active' : ''}`} key={index} onClick={(e) => this.handleNavToggle(e, item.name)}>
                  {item.name}
                </li>
              )
            }
          </ul>
          {this.state.activeTab !== '投资者联系方式' ? (<ul className='Investor-main'>
            {
              this.state.InvestorList.map((item, index) =>
                <li key={index}>
                  <a href={item.url} target="_blank" rel="noopener noreferrer" id={'LINK' + index} title={item.title}>
                    <h4>
                      {item.title.length < 40
                        ? item.title
                        : item.title.substring(0, 40) + '...'}
                    </h4>
                    <p>{item.publistDate}</p>
                  </a>
                </li>
              )
            }
          </ul>) : (
            <div className='investor-contactus'>
              <table>
                <tbody>
                  <tr>
                    <td>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</td>
                    <td>
                      北京市海淀区车公庄西路19号 37幢 4层 401-408
                    </td>
                  </tr>
                  <tr>
                    <td>电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话</td>
                    <td>010-88820307</td>
                  </tr>
                  <tr>
                    <td>传&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;真</td>
                    <td>010-88018550</td>
                  </tr>
                  <tr>
                    <td>董秘邮箱</td>
                    <td>yanglindong@greetec.com</td>
                  </tr>
                  <tr>
                    <td>公司官网</td>
                    <td>www.greetec.com</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )
          }
          {/* </div>
          </section> */}

        </main>
        <Route component={AppFooter} />
      </div>
    );
  }
}

export default Investor;
